import React, { lazy, Suspense } from 'react';
import Loader from '../../components/Loader/Loader.lazy';

const LazyOrderHome = lazy(() => import('./OrderHome'));

const OrderHome = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyOrderHome {...props} />
  </Suspense>
);

export default OrderHome;
